import type { AiSuggestionInteractionPoint } from '@atlaskit/editor-common/analytics';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { addAcceptSuggestionAnalytics } from '../ui/utils/analytics';
import { updateSuggestionStatus } from '../ui/utils/api';
import { applyToolCalls } from '../ui/utils/toolCalls/applyToolCalls';

import type { AcceptSuggestionAction } from './types';

export const acceptSuggestionAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => AcceptSuggestionAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id: string, interactionPoint: AiSuggestionInteractionPoint = 'sidebar'): boolean => {
		const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
		if (!suggestion) {
			return false;
		}

		api?.core?.actions.execute(({ tr }) => {
			addAcceptSuggestionAnalytics(api?.analytics?.actions)(tr, suggestion, interactionPoint);
			tr.setMeta('addToHistory', false);
			return tr;
		});

		api?.core?.actions.execute(({ tr }) => {
			api?.showDiff?.commands.hideDiff?.({ tr });
			applyToolCalls({ tr, suggestion });
			tr.setMeta('scrollIntoView', false);
			tr.setMeta(aiSuggestionsPluginKey, { action: 'ACCEPT_SUGGESTION', suggestion });
			return tr;
		});

		updateSuggestionStatus({ updates: [{ id, status: 'ACTIONED' }] });

		return true;
	};
